import api from './api';

// Translation Settings API calls
export const getTranslationSettings = async () => {
  try {
    const response = await api.get('/admin/search/translation-settings/');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch translation settings');
  }
};

export const getTranslationSetting = async (id) => {
  try {
    const response = await api.get(`/admin/search/translation-settings/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch translation setting');
  }
};

export const createTranslationSetting = async (settingData) => {
  try {
    const response = await api.post('/admin/search/translation-settings/', settingData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create translation setting');
  }
};

export const updateTranslationSetting = async (id, settingData) => {
  try {
    const response = await api.put(`/admin/search/translation-settings/${id}/`, settingData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update translation setting');
  }
};

export const deleteTranslationSetting = async (id) => {
  try {
    await api.delete(`/admin/search/translation-settings/${id}/`);
    return true;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete translation setting');
  }
};

export const activateTranslationSetting = async (id) => {
  try {
    const response = await api.post(`/admin/search/translation-settings/${id}/activate/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to activate translation setting');
  }
};

// Search History API calls
export const getSearchHistory = async (params = {}) => {
  try {
    const queryParams = {};
    if (params.page) queryParams.page = params.page;
    if (params.page_size) queryParams.page_size = params.page_size;
    if (params.ordering) queryParams.ordering = params.ordering;
    
    const response = await api.get('/admin/search/search-history/', { params: queryParams });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch search history');
  }
};

export const clearSearchHistory = async () => {
  try {
    await api.delete('/admin/search/search-history/clear/');
    return true;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to clear search history');
  }
};

// Translation Statistics API calls
export const getTranslationStats = async (params = {}) => {
  try {
    const queryParams = {};
    if (params.days) queryParams.days = params.days;
    
    const response = await api.get('/admin/search/translation-stats/', { params: queryParams });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch translation statistics');
  }
};

export const getPlatformTranslations = async (params = {}) => {
  try {
    const response = await api.get('/admin/search/platform-translations/', { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to fetch platform translations');
  }
};

export const createPlatformTranslation = async (data) => {
  try {
    const response = await api.post('/admin/search/platform-translations/', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to create platform translation');
  }
};

export const updatePlatformTranslation = async (id, data) => {
  try {
    const response = await api.patch(`/admin/search/platform-translations/${id}/`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to update platform translation');
  }
};

export const bulkUpdatePlatformTranslations = async (data) => {
  try {
    const response = await api.post('/admin/search/platform-translations/bulk-update/', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to bulk update platform translations');
  }
};

export const bulkDeletePlatformTranslations = async (data) => {
  try {
    const response = await api.post('/admin/search/platform-translations/bulk-delete/', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to bulk delete platform translations');
  }
};

export const deletePlatformTranslation = async (id) => {
  try {
    await api.delete(`/admin/search/platform-translations/${id}/`);
    return true;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to delete platform translation');
  }
};

export const markPlatformTranslationReviewed = async (id) => {
  try {
    const response = await api.post(`/admin/search/platform-translations/${id}/review/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to mark translation reviewed');
  }
};

export const prefillPlatformTranslation = async (data) => {
  try {
    const response = await api.post('/admin/search/platform-translations/prefill/', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to prefill translation');
  }
};
